import Box from '@mui/material/Box';
import { NodeProps } from 'reactflow';

import type { TimeConstraintNodeData } from '../../../../types';
import TimeConstraintClockIcon from '../../edges/TimeConstraintClockIcon';
import { TimeConstraintErrorIcon } from '../../TimeConstraintErrorIcon';

export const TimeConstraintNode = ({
  data,
}: NodeProps<TimeConstraintNodeData>): JSX.Element | null => {
  if (data === undefined) {
    return null;
  }

  const showErrorState =
    data.errors !== undefined &&
    data.labwareCorrespondence !== 'NO_LABWARE_ASSIGNED';

  return (
    <Box>
      {showErrorState && data.errors !== undefined ? (
        <TimeConstraintErrorIcon errors={data.errors} />
      ) : (
        <TimeConstraintClockIcon
          labwareCorrespondence={data.labwareCorrespondence}
        />
      )}
    </Box>
  );
};
